import { Close } from '@mui/icons-material';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import { shallowEqual } from 'react-redux';
import HrbTranslate from '../../../components/language/HrbTranslate';
import DefaultModal from '../../../components/library/modal/DefaultModal';
import WorkflowStatusIcon from '../../../components/library/workflow-tasks/WorkflowStatusIcon';
import { TaskStatus } from '../../vdo-ticket/services/TaskStatus';
import '../../../stylesheets/custom_scrollbar.scss';
import './AutoAssignModal.scss';
import AutoAssignModalTabbedContainer from './AutoAssignModalTabbedContainer';

const AssociateAutoAssignModal = (props) => {

    const { associate, isOpen, onCancel } = props

    return (
        <DefaultModal isOpen={isOpen} className='autoassign-modal'>
            <div className='columns level header'>
                <div className='column is-1'>
                    <WorkflowStatusIcon status={TaskStatus.IN_PROGRESS} />
                </div>
                <div className='column is-10'>
                    {!!associate &&
                        <h4><HrbTranslate text='AssociateOfficesModal.Title' params={{ TaxExpertName: `${associate.firstName} ${associate.lastName}`.trim() }} /></h4>
                    }
                </div>
                <div className='column is-1 close-btn' onClick={onCancel}>
                    <Close />
                </div>
            </div>
            <AutoAssignModalTabbedContainer {...props} />
        </DefaultModal>
    );
}

AssociateAutoAssignModal.whyDidYouRender = false;

AssociateAutoAssignModal.propTypes = {
    impersonatingId: PropTypes.number,
    associate: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    onUpdated: PropTypes.func,
    onCancel: PropTypes.func
}

export default AssociateAutoAssignModal